import { extend } from 'vee-validate';

extend('includes', {
    validate(value, { values }) {
        return values.indexOf(value.toString()) !== -1;
    },
    params: ['values'],
    message: 'Please select a valid option'
});
